// extracted by mini-css-extract-plugin
export default {"main":"AddMedia_main__zqT0+"};